var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDonors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3333 21.0001C37.0833 21.0001 41.75 16.3334 41.75 10.5834C41.75 4.83341 37.0833 0.166748 31.3333 0.166748C25.5833 0.166748 20.9167 4.83341 20.9167 10.5834C20.9167 16.3334 25.5833 21.0001 31.3333 21.0001ZM42.6875 32.6667C41.875 31.8334 40.8542 31.4167 39.6667 31.4167H25.0833L20.75 29.8959L21.4375 27.9376L25.0833 29.3334H30.9167C31.6458 29.3334 32.2292 29.0417 32.7083 28.5626C33.1875 28.0834 33.4167 27.5001 33.4167 26.8542C33.4167 25.7292 32.875 24.9584 31.7917 24.5209L16.6458 18.9167H12.5833V37.6667L27.1667 41.8334L43.8958 35.5834C43.9167 34.4792 43.5 33.5001 42.6875 32.6667ZM8.41667 18.9167H0.0500031V41.8334H8.41667V18.9167Z",
    fill: "#0E8073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonors);
export default __webpack_public_path__ + "static/media/Donors.03908205efa36265066427f869036f34.svg";
export { ForwardRef as ReactComponent };